import type { InjectionKey, Ref } from "vue";

import { inject, provide } from "vue";

/**
 * 역할이 내려가 화면을 다시 불러와야 하는 동안의 문맥(83차 JR83-05) — `DefaultLayout` 이 주고, 드로어(`SidePanel`) · 모달(`AppModal`)이 머리 아래에 같은 안내를 둔다.
 * 페이지 머리 배너(`.role-reload-callout`)는 `#app` 으로 Teleport 한 드로어 · 모달 층 뒤에 가려져, 열린 층 안에서 저장을 누른 사용자는 왜 안 되는지 볼 수 없었다.
 * 제공자가 없으면(공개 화면 · 층이 `DefaultLayout` 밖) 아무것도 그리지 않는다.
 */
export interface RoleLoweredContext {
  /** 강등으로 쓰기가 잠겼고 아직 화면을 다시 불러오지 않았다 */
  active: Readonly<Ref<boolean>>;
  /** 이탈 가드를 거쳐 화면을 다시 불러온다(저장하지 않은 입력이 있으면 확인창) */
  reload: () => void;
}

export const ROLE_LOWERED: InjectionKey<RoleLoweredContext> =
  Symbol("role-lowered");

/** `DefaultLayout` `setup` 에서 부른다 */
export function provideRoleLowered(context: RoleLoweredContext): void {
  provide(ROLE_LOWERED, context);
}

/** 층(드로어 · 모달) `setup` 에서 부른다 — 제공자가 없으면 `undefined` */
export function useRoleLowered(): RoleLoweredContext | undefined {
  return inject(ROLE_LOWERED, undefined);
}
